export async function loadSvg(url: string): Promise<string> {
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Failed to load SVG: ${response.status}`);
        return await response.text();
    } catch (error) {
        console.warn(`Failed to load SVG from ${url}:`, error);
        return '';
    }
}
